import React from "react";
import { getProducts } from "@/api/products";
import { Filter } from "@/types/broadbandProduct";
import { Product } from "@/types/broadbandProduct";

const speedFilterValues: Array<Filter> = [
	{
		name: "10Mb +",
		value: 10,
		isChecked: false,
	},
	{
		name: "30Mb +",
		value: 30,
		isChecked: false,
	},
	{
		name: "60Mb +",
		value: 60,
		isChecked: false,
	},
	{
		name: "100Mb +",
		value: 100,
		isChecked: false,
	},
];

const networkFilterValues: Array<Filter> = [
	{
		name: "BT",
		value: "BT",
		isChecked: false,
	},
	{
		name: "Virgin Media",
		value: "Virgin Media",
		isChecked: false,
	},
	{
		name: "TalkTalk",
		value: "TalkTalk",
		isChecked: false,
	},
	{
		name: "Sky",
		value: "Sky",
		isChecked: false,
	},
	{
		name: "NOW",
		value: "NOW",
		isChecked: false,
	},
	{
		name: "Vodafone",
		value: "Vodafone",
		isChecked: false,
	},
	{
		name: "EE",
		value: "EE",
		isChecked: false,
	},
	{
		name: "Plusnet",
		value: "Plusnet",
		isChecked: false,
	},
	{
		name: "Italk",
		value: "Italk",
		isChecked: false,
	},
	{
		name: "Shell Energy Broadband",
		value: "Shell Energy Broadband",
		isChecked: false,
	},
	{
		name: "John Lewis",
		value: "John Lewis",
		isChecked: false,
	},
	{
		name: "Cuckoo",
		value: "Cuckoo",
		isChecked: false,
	},
];

const contractFilterValues: Array<Filter> = [
	{
		name: "Rolling",
		value: 1,
		isChecked: false,
	},
	{
		name: "12 Months",
		value: 12,
		isChecked: false,
	},
	{
		name: "18 Months",
		value: 18,
		isChecked: false,
	},
	{
		name: "24 Months",
		value: 24,
		isChecked: false,
	},
];

const useBroadbandComparison = (broadbandProducts: any) => {
	const [sorter, setSorter] = React.useState<string>("recommended");
	const [products, setProducts] =
		React.useState<Array<Product>>(broadbandProducts);
	const [viewableDeals, setViewableDeals] = React.useState<number>(10);
	const [totalDeals, setTotalDeals] = React.useState<number>(products.length);
	const [speedFilters, setSpeedFilters] =
		React.useState<Array<Filter>>(speedFilterValues);
	const [networkFilters, setNetworkFilters] =
		React.useState<Array<Filter>>(networkFilterValues);
	const [contractFilters, setContractFilters] =
		React.useState<Array<Filter>>(contractFilterValues);
	const [postcode, setPostcode] = React.useState<string>("");
	const [loading, setLoading] = React.useState<boolean>(false);

	const toggleSpeedFilter = (speedFilter: string | number) => {
		const newSpeedFilters = speedFilters.map((filter) => {
			if (filter.value.toString() === speedFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setSpeedFilters(newSpeedFilters);
	};

	const toggleNetworkFilter = (networkFilter: string | number) => {
		const newNetworkFilters = networkFilters.map((filter) => {
			if (filter.value === networkFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setNetworkFilters(newNetworkFilters);
	};

	const toggleContractFilter = (contractFilter: string | number) => {
		const newContractFilters = contractFilters.map((filter) => {
			if (filter.value.toString() === contractFilter) {
				return { ...filter, isChecked: !filter.isChecked };
			}
			return filter;
		});
		setContractFilters(newContractFilters);
	};

	const clearFilters = () => {
		setSpeedFilters(speedFilterValues);
		setNetworkFilters(networkFilterValues);
		setContractFilters(contractFilterValues);
		setViewableDeals(10);
	};

	const filterProductsByPostcode = async () => {
		setLoading(true);
		let filteredProducts: Array<Product> = [];

		const postcodeProducts = await getProducts(postcode);
		if (postcodeProducts.data !== null) {
			filteredProducts = postcodeProducts.data;
		}
		setLoading(false);
		return filteredProducts;
	};

	React.useEffect(() => {
		const getProducts = async () => {
			let filteredProducts = await filterProductsByPostcode();
			setProducts(filteredProducts);
		};

		getProducts();
	}, [postcode]);

	const handlePostcodeChange = (postcode: string) => {
		setPostcode(postcode);
		window.localStorage.setItem("postcode", postcode);
	};

	React.useEffect(() => {
		const savedPostcode = window.localStorage.getItem("postcode");
		if (savedPostcode) {
			setPostcode(savedPostcode);
			getProducts(savedPostcode);
		}
	}, []);

	return {
		products,
		setProducts,
		viewableDeals,
		setViewableDeals,
		totalDeals,
		setTotalDeals,
		speedFilters,
		toggleSpeedFilter,
		networkFilters,
		toggleNetworkFilter,
		contractFilters,
		toggleContractFilter,
		sorter,
		setSorter,
		clearFilters,
		postcode,
		handlePostcodeChange,
		filterProductsByPostcode,
		loading,
	};
};

export default useBroadbandComparison;
